type ImageDimensions = {
  originalWidth?: number
  originalHeight?: number
}

export const getImageUrl = (
  baseUrl: string,
  crop: string,
  filename: string,
  width: number,
  isOriginalSize: boolean,
  format: 'webp' | 'jpg' = 'webp',
  dims: ImageDimensions = {},
) => {
  const { originalWidth, originalHeight } = dims

  if (crop === 'freecrop' && isOriginalSize && originalWidth && originalHeight) {
    return `${baseUrl}o/${originalWidth}/${originalHeight}/${filename}.${format}`
  }

  if (isOriginalSize) {
    return `${baseUrl}o/${width}/${width}/${filename}.${format}`
  }

  return `${baseUrl}${crop}/${width}/${filename}.${format}`
}
